/** Доступные пользователю цвета парковок. */
export const PARKING_COLORS = Object.freeze([
  {value: "turquoise", hex: "#2FC4B2"},
  {value: "blue", hex: "#55A4E8"},
  {value: "green", hex: "#4CA25E"},
  {value: "pink", hex: "#CE7890"},
  {value: "orange", hex: "#D09557"},
  {value: "purple", hex: "#9A82CB"},
  {value: "coral", hex: "#D16F66"},
  {value: "slate", hex: "#77869A"},
  {value: "mustard", hex: "#CFAB5B"},
  {value: "magenta", hex: "#B94770"},
]);

/** Поля комплекса, необходимые странице списка и редактору. */
export const PARKING_AREA_FIELDS = Object.freeze([
  "id",
  "name",
  "bbox_min_lon",
  "bbox_max_lon",
  "bbox_min_lat",
  "bbox_max_lat",
  "bbox_centroid",
  "parking_ids",
  "total_spots_count",
  "free_spots_count",
]);

/** Поля парковки, используемые карточками, редактором и картой. */
export const PARKING_FIELDS = Object.freeze([
  "id",
  "name",
  "color",
  "total_spots_count",
  "free_spots_count",
  "camera_numbers",
  "parking_area_ids",
  "polygon",
  "polygon_min_lon",
  "polygon_max_lon",
  "polygon_min_lat",
  "polygon_max_lat",
  "polygon_centroid",
]);

/** Запрос списка комплексов вместе с входящими в них парковками. */
export const PARKING_AREAS_REQUEST = Object.freeze({
  page: 1,
  page_size: 60,
  fields: PARKING_AREA_FIELDS,
  extra: ["parking"],
});

/** Запрос камер с аналитикой парковочных мест, ещё не привязанных к парковке. */
export const PARKING_ANALYTICS_CAMERAS_REQUEST = Object.freeze({
  page: 1,
  page_size: 100,
  fields: ["camera_number"],
  filters: [{field: "parking_id", lookup: "is_null", argument: true, exclude: false}],
});
